import { CustomButton, Modal } from "@helloaudio/ui";
import { FunctionComponent } from "react";

import { ExclamationCircleIcon } from "@heroicons/react/24/outline";

interface PaymentErrorModalProps {
  visible?: boolean;
  onClose?: () => void;
}
const PaymentErrorModal: FunctionComponent<PaymentErrorModalProps> = ({ visible, onClose }) => {
  return (
    <Modal
      title="Error"
      visible={visible}
      onClose={onClose}
      actions={[
        <CustomButton key="error" onClick={onClose}>
          Close
        </CustomButton>,
      ]}
    >
      <div className="tw-p-8">
        <div className="tw-mx-auto tw-flex tw-items-center tw-justify-center tw-h-12 tw-w-12 tw-rounded-full tw-bg-red-100">
          <ExclamationCircleIcon className="tw-h-8 tw-w-8 tw-text-red-600" aria-hidden="true" />
        </div>
        <div className="tw-mt-3 tw-text-center sm:tw-mt-5">
          <h3
            className="tw-text-lg tw-leading-6 tw-font-medium tw-text-gray-900"
            id="headlessui-dialog-title-:r1i:"
          >
            Payment did not go through!
          </h3>
          <div className="tw-my-2 tw-px-8">
            <p className="tw-text-sm tw-text-gray-500">Update your payment method and try again.</p>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default PaymentErrorModal;
